import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { TextArea } from 'foundations-components/transitional/components/TextArea';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { useGetErrorMessagesAndTranslations } from '../../hooks/useGetErrorMessagesAndTranslations';
import { setErrorMessages, getShowAllErrors } from '../../state/errorMessagesSlice';
import { jsx as _jsx } from "react/jsx-runtime";
const CustomFormFieldTextArea = ({
  disabled,
  formField,
  onChange,
  value = ''
}) => {
  const dispatch = useDispatch();
  const showAllErrors = useSelector(getShowAllErrors);
  const [hasBeenBlurred, setHasBeenBlurred] = useState(false);
  const isError = formField.required && (showAllErrors || hasBeenBlurred) && !value;
  const fieldLabel = formField.label;
  const errorKey = `empty${fieldLabel}`;
  const errorMessage = useGetErrorMessagesAndTranslations().get(errorKey);
  useEffect(() => {
    dispatch(setErrorMessages({
      [errorKey]: {
        isError,
        customFormFieldLabel: fieldLabel
      }
    }));
  }, [isError, dispatch, fieldLabel, errorKey]);
  return /*#__PURE__*/_jsx(FormControl, {
    help: formField.description,
    label: fieldLabel,
    required: formField.required,
    error: isError,
    validationMessage: isError && errorMessage,
    paddingBlockStart: "100",
    children: /*#__PURE__*/_jsx(TextArea, {
      "data-test-id": "custom-form-field-input-text-area",
      disabled: disabled,
      name: formField.name,
      onChange: onChange,
      use: "on-dark",
      value: value,
      onBlur: () => setHasBeenBlurred(true)
    })
  });
};
export default CustomFormFieldTextArea;